import { resetContext, getContext } from 'kea'

import createHistory from 'history/createBrowserHistory'
import { routerReducer, routerMiddleware } from 'react-router-redux'

import { sagaPlugin } from 'kea-saga'
// import localStoragePlugin from 'kea-localstorage'

export const history = createHistory()

// Kea 3.x: plugins must be activated via resetContext (createStore() alone does
// NOT activate them). resetContext activates sagaPlugin and then lazily creates
// the redux store with the saga middleware wired in, so logic sagas actually run.
resetContext({
  plugins: [
    sagaPlugin,
    // localStoragePlugin
  ],
  createStore: {
    middleware: [
      routerMiddleware(history)
    ],
    reducers: {
      router: routerReducer,
    },
  },
})

export const store = getContext().store

export const routeSelector = (state) => state.router.location
